var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selectorLabel"},[_vm._v(_vm._s(_vm.label)),(_vm.hasageStandardizedWord)?_c('div',{staticClass:"selectorLabel_ageStandardized"},[_vm._v(_vm._s(_vm.ageStandardizedLabel))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }